module.exports = __webpack_public_path__ + "img/10-green-diamond.a5a385ce.png";